import { useTranslation } from 'react-i18next';

import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationPrevious,
  PaginationNext
} from '@/components/ui/pagination';

interface NavigationControlsProps {
  currentIndex: number;
  totalConsignments: number;
  canGoPrevious: boolean;
  canGoNext: boolean;
  onPrevious: () => void;
  onNext: () => void;
}

export function NavigationControls({
  currentIndex,
  totalConsignments,
  canGoPrevious,
  canGoNext,
  onPrevious,
  onNext
}: NavigationControlsProps) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-4">
      <span className="text-sm text-muted-foreground">
        {t('newcmr.pagination.label', 'Consignment {{current}} of {{total}}', {
          current: currentIndex + 1,
          total: totalConsignments
        })}
      </span>
      <Pagination>
        <PaginationContent>
          <PaginationItem>
            <PaginationPrevious
              onClick={onPrevious}
              className={!canGoPrevious ? 'pointer-events-none opacity-50' : 'cursor-pointer'}
              aria-disabled={!canGoPrevious}
            />
          </PaginationItem>
          <PaginationItem>
            <PaginationNext
              onClick={onNext}
              className={!canGoNext ? 'pointer-events-none opacity-50' : 'cursor-pointer'}
              aria-disabled={!canGoNext}
            />
          </PaginationItem>
        </PaginationContent>
      </Pagination>
    </div>
  );
}
